<section class='fs-4'>{{dialogConfig.data.details}}</section>
